export enum AutomationTab {
  DEALS = 'DEALS',
  CHATS = 'CHATS',
  PLANNERS = 'PLANNERS',
}

export enum FunnelSettingsTab {
  COMMON = 'COMMON',
  COLUMNS = 'COLUMNS',
  FIELDS = 'FIELDS',
}

export enum PowerOlxV2Tab {
  ADVERTS = 'ADVERTS',
  PLANNERS = 'PLANNERS',
  BACKUPS = 'BACKUPS',
  PACKAGES = 'PACKAGES',
  TEMPLATES = 'TEMPLATES',
  DELIVERIES = 'DELIVERIES',
}

export enum PowerOlxTab {
  MY_ADVERTS = 'MY_ADVERTS',
  MY_PLANNERS = 'MY_PLANNERS',
  MY_BACKUPS = 'MY_BACKUPS',
  MY_PACKETS = 'MY_PACKETS',
  MY_TEMPLATES = 'MY_TEMPLATES',
  MY_DELIVERIES = 'MY_DELIVERIES',
}

export enum ProfileTab {
  PROFILE = 'PROFILE',
  SETTINGS = 'SETTINGS',
}

export enum SupportTab {
  VIDEO = 'VIDEO',
  FAQ = 'FAQ',
  CONTACT = 'CONTACT',
  TICKET = 'TICKET',
}

export enum TeamTab {
  INVITERS = 'INVITERS',
  MANAGERS = 'MANAGERS',
  GROUPS = 'GROUPS',
}

export enum LogisticTab {
  GENERAL = 'GENERAL',
  TRACKERS = 'TRACKERS',
  TEMPLATES = 'TEMPLATES',
  INVOICES = 'INVOICES',
}

export enum LogisticSettingsTab {
  TELEGRAM = 'TELEGRAM'
}

export enum CardTab {
  GENERAL = 'GENERAL',
}

export enum PaymentsTab {
  PAYMENT = 'PAYMENT',
  ADDITIONAL_CHANNELS = 'ADDITIONAL_CHANNELS',
  TOKEN = 'TOKEN',
  PAYMENT_HISTORY = 'PAYMENT_HISTORY',
}

export enum NotificationTab {
  INBOX = 'INBOX',
  ARCHIVED = 'ARCHIVED',
}

export enum CompanySettingsTab {
  GENERAL = 'GENERAL',
  SECURITY = 'SECURITY',
}
